<ng-container *ngIf="!loadingTranslations">
    <!-- HEADER -->
    <teiasoft-header [headerHidePages]="['login']" [title]="'Quotation Tool'"
        (onClick)="onMenuClick($event)" [showSettings]="true" [theme]="globals.theme!" [user]="globals.userLogged"
        [userName]="(globals.userLogged ? globals.userLogged!.username + ' (' + globals.userLogged!.name + ' ' + globals.userLogged!.surname + ')' : '')"
        (onChangeUsersSettings)="onChangeUserSettings($event)"></teiasoft-header>

    <router-outlet *ngIf="configurationLoadCompleted"></router-outlet>

    <!-- LOADER [spinnerImage]="'./assets/images/logo_ong_def.png'" -->
    <teiasoft-loader></teiasoft-loader>

    <!-- TOASTER -->
    <teiasoft-toast [isMobile]="!globals.isDesktop!"></teiasoft-toast>

    <!-- MODAL -->
    <teiasoft-modal [theme]="globals.theme!" [isMobile]="false" [scope]="'app-global-error'"></teiasoft-modal>
</ng-container>
